<template>
  <div
    id="dungeons"
    class="relative flex flex-col items-center justify-center h-full bg-dungeon-section bg-no-repeat bg-auto py-16 px-2 overflow-hidden"
  >
    <section-title titlePath="title-4.png" />
    <div class="btns flex flex-row flex-wrap justify-center w-full mb-11">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-158 h-54 m-1 text-white font-elmessiri text-xl flex justify-center items-center bg-btn-off bg-cover bg-no-repeat bg-center"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="dungeonList"
      tag="div"
      class="relative w-full h-440 flex justify-center items-start"
      :css="false"
      v-on:enter="enter"
      v-on:leave="leave"
      v-on:before-enter="beforeEnter"
      v-on:before-leave="beforeleave"
    >
      <div
        class="absolute w-full max-w-790 lg:max-w-538"
        v-for="(dungeon, index) in dungeonData"
        :key="dungeon.image"
        v-show="menuData[index].isActive"
      >
        <div class="flex flex-col justify-start items-center">
          <img :src="`${imgPath}${dungeon.image}`" />
          <div
            class="w-full max-w-660 min-h-192 font-nunito text-left text-sm text-grayish-orange px-9"
            v-html="dungeon.text"
          ></div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: { SectionTitle },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      menuData: [
        {
          text: 'EXP',
          isActive: true,
        },
        {
          text: 'Item/Ely',
          isActive: false,
        },
        {
          text: 'TAID',
          isActive: false,
        },
      ],
      dungeonData: [
        {
          image: '/slide5/img_exp.png',
          text:
            'Experience dungeons are the bread and butter of all dungeons. It focuses more heavily on experience points. These dungeons are utilized to level up your character to provide more basic stats and other effects such as Ascension stats.<br/><br/>Dungeons will consist of regular mobs, mini-boss, and the final boss. Once the final boss is eliminated, you will be able to claim your rewards in the Reward Room. There are difficulty settings as well, so if you are having struggles clearing the dungeon in normal mode, try easy mode and see if you can clear it!',
        },
        {
          image: '/slide5/img_itemely.png',
          text:
            'Most high-leveled items are acquired in specific dungeons. In order to be stronger, you must be able to conquer these dungeons in order to obtain better equipment items.<br/><br/>In order to check the best equipment for a specific slot, please check the guidebook. These items consist of 6 types of Badges, Brooch, Textbook, Belt, Sticker, Necklace, etc.',
        },
        {
          image: '/slide5/img_taid.png',
          text:
            'Some dungeons are marked as "TAID" (Time Attack Instance Dungeon). These dungeons have a specific time limit for you to clear the dungeons.<br/><br/>Some weekly challenges consist of advanced TAIDs. Try to finish all TAID dungeons as fast as you can!',
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuIndex === i) {
          this.menuData[i].isActive = true;
        } else {
          this.menuData[i].isActive = false;
        }
      }
    },
    beforeEnter: function(el) {
      gsap.to(el, { position: 'relative' });
    },
    enter: function(el, done) {
      gsap.fromTo(el, { autoAlpha: 0 }, { autoAlpha: 1, onComplete: done });
    },
    beforeleave: function(el) {
      gsap.to(el, { position: 'absolute' });
    },
    leave: function(el, done) {
      gsap.fromTo(el, { autoAlpha: 1 }, { autoAlpha: 0, onComplete: done });
    },
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-btn-on;
}
</style>
